export const environment = {
  production: true,
  local: false,
  apiUrl: 'https://eventshop-api-p-we.azurewebsites.net',
  frontendUrl: 'https://joinandmove.dk',
};
